import { sup } from './FootnotesMarker.css';
import type { TPostFootnotesMarkerProps } from './FootnotesMarker.types';

export const PostFootnotesMarker = ({ element }: TPostFootnotesMarkerProps) => {
  const { attrs } = element;

  return (
    <a
      href={`#${attrs.footnoteId}`}
      target="_self"
      title={`${attrs.order} ${attrs.footnoteText}`}
      data-skip-tracking="true"
    >
      <sup className={sup}>{attrs.order}</sup>
    </a>
  );
};
